module.exports = __webpack_public_path__ + "static/media/plus.546cd401.svg";